import React from 'react';
import { Icon } from 'semantic-ui-react';
import Message from 'components/Message';
import InlineEditIconButton from 'components/InlineEditIconButton';

function OrderRowContent({ product, textDecorationStyle, textColorStyle, onEditOrder, onToggleReady }) {
  const isPending = product.delivered_at === null;

  const handleReadyControlClick = (e) => {
    e.stopPropagation();
    onToggleReady(product);
  };

  const handleReadyControlKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onToggleReady(product);
    }
  };
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
      minWidth: 0,
      gap: '8px',
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', flex: 1, minWidth: 0 }}>
        <span style={{ 
          width: '30px', 
          height: '30px', 
          borderRadius: '50%', 
          backgroundColor: product.delivered_at ? '#e9e9e9' : '#f0f8ff',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginRight: '10px',
          flexShrink: 0,
          marginTop: '2px'
        }}>
          <b style={{ fontSize: '16px' }}>
            {product.quantity}
          </b>
        </span>

        <span style={{ 
          color: textColorStyle, 
          textDecoration: textDecorationStyle, 
          fontWeight: 'bold',
          fontSize: '18px',
          flex: 1,
          minWidth: 0,
          lineHeight: 1.5,
          wordBreak: 'break-word',
        }}>
          {product.product_name}
          {isPending && onEditOrder && (
            <InlineEditIconButton
              ariaLabel="Editar artículo"
              onClick={(e) => {
                e.stopPropagation();
                onEditOrder(product);
              }}
              style={{ marginLeft: '8px', display: 'inline-flex', verticalAlign: 'middle' }}
            />
          )}
        </span>
      </div>

      <div
        role="button"
        tabIndex={0}
        aria-label={isPending ? 'Marcar artículo como listo' : 'Marcar artículo como pendiente'}
        onClick={handleReadyControlClick}
        onKeyDown={handleReadyControlKeyDown}
        style={{
          flexShrink: 0,
          alignSelf: 'center',
          cursor: 'pointer',
          padding: '6px',
          margin: '-6px',
          lineHeight: 0,
        }}
      >
        {product.delivered_at === null ? (
          <Icon name="circle outline" color="blue" size="large" />
        ) : (
          <Icon name="undo" color="grey" size="large" />
        )}
      </div>
    </div>
  );
}

export default function BillProducts({ products, toggleProductReadyFn, pendingOrders, onEditOrder }) {

  const toggleProductReadyStatus = (product) => {
    toggleProductReadyFn(product.id);
  }
  
  if (!products || products.length === 0) {
    return (
      <Message>
        Aún no tienes ordenes en esta cuenta. Para agregar una nueva orden, dale click al botón de "+".
      </Message>
    )
  }

  let summary = null;

  if (pendingOrders.length === 0) {
    summary = (
      <span style={{ fontSize: '1.2em', marginRight: '5px' }}>
        Sin ordenes pendientes
      </span>
    )
  }

  if (pendingOrders.length === 1) {
    summary = (
      <span style={{ fontSize: '1.2em', marginRight: '5px' }}>
        <span style={{ fontWeight: 'bold' }}>1</span> orden pendiente
      </span>
    )
  }
  
  if (pendingOrders.length > 1) {
    summary = (
      <span style={{ fontSize: '1.2em', marginRight: '5px' }}>
        <span style={{ fontWeight: 'bold' }}>{pendingOrders.length}</span> ordenes pendientes
      </span>
    )
  }
  
  return (
    <div style={{ marginBottom: '2em' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        margin: '0.5em 0 1em 0',
        padding: '8px 0',
        borderBottom: '1px solid #ddd'
      }}>
        {summary}
        {pendingOrders.length === 0 &&
          <Icon name="check" size="large" color="green" />
        }
      </div>
      
      <div>
        {products.map((product) => {
          const textDecorationStyle = product.delivered_at ? 'line-through' : 'none';
          const textColorStyle = product.delivered_at ? 'darkgray' : '';
          const isPending = product.delivered_at === null;

          return (
            <div 
              key={product.id} 
              style={{ 
                display: 'flex', 
                justifyContent: 'flex-start', 
                alignItems: 'flex-start', 
                marginBottom: '10px',
                padding: '12px 5px',
                borderRadius: '8px',
                backgroundColor: isPending ? '#fff' : '#f8f8f8',
                border: '1px solid #eee',
                transition: 'background-color 0.2s'
              }}
            >
              <OrderRowContent
                product={product}
                textDecorationStyle={textDecorationStyle}
                textColorStyle={textColorStyle}
                onEditOrder={onEditOrder}
                onToggleReady={toggleProductReadyStatus}
              />
            </div>
          );
        })}
      </div>
    </div>
  )
}
